import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import Icon, { IconProps } from 'shared/library/atoms/Icon'

interface PinPros {
  /**
   * Loads an Activity Type Icon.
   */
  icon?: IconProps['name']
  children?: ReactNode
  /**
   * Allows more props. corresponds to ...other.
   * We need it for styled-system.
   */
  [propName: string]: unknown
}

const Pin = ({ icon, children, ...other }: PinPros) => {
  return (
    <StyledPin color="secondary" {...other}>
      {!!icon && (
        // Use my={'-3px'} to reduce the occupied space without decreasing the dimensions
        // It will help the component to be 32px height by default
        <Icon name={icon} mr={2} my={'-3px'} color="grey" />
      )}
      {children}
    </StyledPin>
  )
}

export default Pin

const StyledPin = styled.div(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  border: theme.border,
  padding: `${theme.space[1]}px ${theme.space[2]}px`,
  borderRadius: theme.radii[5],
  textTransform: 'uppercase',
  ...theme.fontStyle.h6,
  lineHeight: 1, // Overwrite line height to prevent the extra space of increasing the height of the Pin
  marginTop: 'auto', // Overwrite top and bottom margin to horizontally align with price
  marginBottom: 'auto',
  backgroundColor: theme.colors.white,
  span: {
    display: 'block',
    background: 'currentColor',
    marginRight: 5,
    width: theme.space[4],
    height: theme.space[4],
    borderRadius: '50%'
  }
}))
